// =============================================================================
// features/configuracoes/comercial/CancelamentosSection.tsx — Grupo
// "Cancelamentos e supressões" (doc 26 §6.9): motivos aceitos em cada caso.
// =============================================================================

import * as React from 'react';

import { ReasonListEditor } from './ReasonListEditor';
import { SettingsCard } from './SettingsCard';
import type { SettingsDraft } from './types';

interface CancelamentosSectionProps {
  draft: SettingsDraft;
  isDefault: boolean;
  onChange: (updates: Partial<SettingsDraft>) => void;
  disabled?: boolean;
}

export function CancelamentosSection({
  draft,
  isDefault,
  onChange,
  disabled = false,
}: CancelamentosSectionProps): React.JSX.Element {
  return (
    <SettingsCard
      title="Cancelamentos e supressões"
      description="Motivos aceitos ao cancelar um compromisso ou suprimir um lead de futuras tentativas."
      isDefault={isDefault}
    >
      <ReasonListEditor
        idPrefix="comercial-cancellation"
        label="Motivos de cancelamento"
        hint="Exibidos ao cancelar um compromisso da agenda comercial"
        items={draft.cancellationReasons}
        disabled={disabled}
        onChange={(cancellationReasons) => onChange({ cancellationReasons })}
      />
      <ReasonListEditor
        idPrefix="comercial-suppression"
        label="Motivos de supressão"
        hint="Exibidos ao suprimir um lead de novas tentativas de contato"
        items={draft.suppressionReasons}
        disabled={disabled}
        onChange={(suppressionReasons) => onChange({ suppressionReasons })}
      />
    </SettingsCard>
  );
}
